export class DataNotIndexedYetError extends Error {    
    constructor(...params) {
        // @ts-ignore
        super(...params)

        this.name = "DataNotIndexedYetError"
    }
}